/**
 * Phase E E.5 — Bouton OCR Claude Vision sur une facture.
 *
 * Endpoint backend reel : POST /api/chantiers/{cid}/factures/{fid}/extract
 * (decouverte audit Phase E.5 : il faut chantier_id en plus du facture_id).
 */
import { useState } from 'react';
import axios from 'axios';
import { MagicWand, ArrowsClockwise } from '@phosphor-icons/react';
import useIA from '../../../hooks/useIA';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function FactureOCRButton({ facture, chantierId, onUpdate }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // RP96 — réglage IA du cabinet : bouton grisé avec explication si non disponible
  const ia = useIA();
  const iaOff = !ia.disponible('lecture_documents');

  // N'afficher que si TVA/TTC/fournisseur manquent ou si on veut retenter
  const needsOCR =
    !facture?.montant_ttc ||
    facture?.tva === null ||
    facture?.tva === undefined ||
    !facture?.entreprise;

  if (!needsOCR && !error && facture?.ocr_status === 'done') {
    // Petite indication discrete que l'OCR a deja tourne avec succes
    return (
      <span className="text-xs text-gray-400" title="Données déjà extraites par l'Assistant">
        ✓ OCR
      </span>
    );
  }

  const handleOCR = async () => {
    if (
      !window.confirm(
        'Extraire les données de cette facture avec l\'Assistant ? Quelques secondes.',
      )
    )
      return;
    setLoading(true);
    setError(null);
    try {
      const fid = facture._id || facture.id;
      const res = await axios.post(
        `${API_URL}/api/chantiers/${chantierId}/factures/${fid}/extract`,
        null,
        { withCredentials: true },
      );
      onUpdate?.(res.data);
    } catch (e) {
      setError(e?.response?.data?.detail || e?.message || 'Erreur OCR');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="inline-flex flex-col items-start gap-1">
      <button
        onClick={handleOCR}
        disabled={loading || iaOff}
        className="px-2 py-1 text-xs bg-purple-50 text-purple-700 border border-purple-200 rounded hover:bg-purple-100 flex items-center gap-1 disabled:opacity-50"
        title={ia.raison('lecture_documents') || "Extraire les données avec l'Assistant"}
        data-testid="facture-ocr-button"
      >
        {loading ? <ArrowsClockwise size={14} className="animate-spin" /> : <MagicWand size={14} />}
        {loading ? 'Extraction…' : 'OCR IA'}
      </button>
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
